///////////////////
// 
///////////////////
import { OnInit, Component, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthenticationService } from '../../../core/auth/authentication.service';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';


@Component({
    selector: 'djiv-forgot-password-form',
    templateUrl: './djiv-forgot-password-form.component.html',
    styleUrls: ["./djiv-forgot-password-form.component.css"]
})

export class DJIVForgotPasswordForm implements OnInit {   

    public $emailForm: FormGroup;
    public $Error: string;
    public valueForm: string;
    public requestPending: boolean = false;
    // public emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";

    protected $router: Router;
    protected $authenticationService: AuthenticationService;

    private http: HttpClient;

    public pressBtnRequestNewPass: boolean = false; 
    public requestSuccess: boolean = false;

    constructor(protected $injector: Injector) {
        this.$router = $injector.get(Router);  
        this.http = $injector.get(HttpClient);

        this.$emailForm = new FormGroup({
            email: new FormControl('',  [Validators.required, Validators.email])// Validators.pattern(this.emailPattern)])
        });       
    }

    ngOnInit() {
        this.valueForm ="modules.Application.views.forgotPassword.textFooterDefault";
    }

    public requestPassword(){

        if (this.$emailForm.invalid) {            
            this.valueForm = "modules.Application.views.forgotPassword.textFooterInvalidEmail"
            return;
        }   

        this.requestPending = true;

        const url = `${environment.getDataProviders()["SupplierAppProvider"].serviceUri}/web/pdo/Unauthenticated/PusrBusinessEntity/ResetPasswordRequest`;
        
        this.http.put(url, JSON.stringify(this.$emailForm.value), 
            { 
                headers: {'Content-Type': 'application/json'},
                withCredentials: true
            }).subscribe(result => {
                this.pressBtnRequestNewPass = true;
                this.requestSuccess = true;
                this.requestPending = false;
            }, error => {
                this.pressBtnRequestNewPass = true;
                this.requestSuccess = false;
                this.requestPending = false;
            });
        
    }

    public backBtn(){
        this.$router.navigate(['auth-callback']);
    }

}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-forgot-password-form/djiv-forgot-password-form.component.ts